function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 12.5,
  r: 12.5,
  fill: "#E2E2E3"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.4285 7.00007H14.7414C14.4714 6.25436 13.7643 5.71436 12.9285 5.71436C12.0928 5.71436 11.3857 6.25436 11.1157 7.00007H8.42854C7.72139 7.00007 7.14282 7.57864 7.14282 8.28578V17.2858C7.14282 17.9929 7.72139 18.5715 8.42854 18.5715H17.4285C18.1357 18.5715 18.7143 17.9929 18.7143 17.2858V8.28578C18.7143 7.57864 18.1357 7.00007 17.4285 7.00007ZM12.9287 7.00007C13.2823 7.00007 13.5716 7.28936 13.5716 7.64293C13.5716 7.9965 13.2823 8.28578 12.9287 8.28578C12.5751 8.28578 12.2859 7.9965 12.2859 7.64293C12.2859 7.28936 12.5751 7.00007 12.9287 7.00007ZM9.71418 16.0001H14.2142V14.7144H9.71418V16.0001ZM16.1428 13.4287H9.71418V12.143H16.1428V13.4287ZM9.71418 10.8573H16.1428V9.57157H9.71418V10.8573Z",
  fill: "#979797"
});
const SvgScheduledIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgScheduledIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/scheduled-icon.4a7152f2.svg";
export { ForwardRef as ReactComponent };